import styled from 'styled-components';
import Badge from '@mui/material/Badge';
import { Colors } from '../../../theme';
import { subTitle2 } from '../styles/fonts';
import { StyledLinkV2 } from '../styles/ui';
import { HEADER_TYPE } from '../types';
export const CustomNav = styled.nav `
  display: ${({ $type }) => ($type === HEADER_TYPE.Integrated ? 'none' : 'initial')};
  flex: 1;
  margin: 0 0 210px;
`;
export const CustomSection = styled.section `
  flex: 1;
`;
export const CustomListItem = styled.li `
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
`;
export const CustomLink = styled(StyledLinkV2) `
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.grey900};
  ${subTitle2};

  &.MuiLink-root:hover,
  &.MuiLink-root:focus,
  &.MuiLink-root:active {
    color: ${({ $isActive }) => ($isActive ? Colors.blue400 : Colors.grey900)};
    text-decoration: none;
    background: none;
  }

  .MuiSvgIcon-root {
    font-size: 30px;
  }
`;
export const CustomBadge = styled(Badge) `
  .MuiBadge-badge {
    right: -8px;
  }
`;
//# sourceMappingURL=styles.js.map